import { getFromApi, postToApi } from 'actions'
import { setDefaultSelectedOptions, convertArrayToMap, deselectItems, getSelectedOptionsWithParent } from './utils'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'

export async function getAllItems(
   urlBase,
   optionsMap,
   parentItemSingularName,
   parentItemPluralName,
   itemPluralName,
   setItemsLists
) {
   const result = Object.keys(optionsMap[parentItemPluralName]).map(
      (accParams, index) => {
      const name = `${parentItemPluralName}Id`
      return { [name]: accParams }
   }
)
   const url = `${urlBase}/${itemPluralName}/search/${parentItemPluralName}`
   const searchedItems = await postToApi(url, result)
   const parentItemsMap = {}
   const visibleItemsMap = {}
   searchedItems.forEach(item => {
      const parentItemId = item[parentItemSingularName].id
      if (!visibleItemsMap[parentItemId]) {
         visibleItemsMap[parentItemId] = {
            name: item[parentItemSingularName].name,
            visible: true
         }
      }
      if (!parentItemsMap[parentItemId]) {
         parentItemsMap[parentItemId] = {}
      }
      parentItemsMap[parentItemId][item.id] = {
         name: item.name,
         checked: false
      }
   })
   Object.keys(parentItemsMap).forEach(parentItemId => {
      const itemsMap = setDefaultSelectedOptions(
         parentItemsMap[parentItemId], 
         optionsMap[itemPluralName]
      )
      visibleItemsMap[parentItemId] = {
         ...visibleItemsMap[parentItemId],
         itemsMap
      }
   })
   setItemsLists(previous => ({
      ...previous,
      ...visibleItemsMap
   }))
}

export function hideItemsLists(itemsLists, setItemsLists) {
   const unselectedItemsLists = Object.keys(itemsLists).map(parentItemId => ({
      ...itemsLists[parentItemId],
      visible: false
   }))
   setItemsLists(unselectedItemsLists)
}

const PAGING_ORDER = {
   page: 0,
   size: 10000,
   order: 'asc',
   columnOrder: 'name'
}
export async function searchItemsByParentItemId(
   url,
   parentItemIdKey,
   parentItemId,
   parentItemName,
   setItemsLists,
   errorMessage,
   dispatch
) {
   const payload = {
      [parentItemIdKey]: parentItemId,
      status: 'A',
      ...PAGING_ORDER
   }
   const { data: searchedItems } = await getFromApi(url, payload)
   if (searchedItems && searchedItems.length) {
      const itemsMap = convertArrayToMap(searchedItems)
      setItemsLists(previous => ({
         ...previous,
         [parentItemId]: {
            visible: true,
            name: searchedItems[0][parentItemName].name,
            itemsMap
         }
      }))
   } else {
      dispatch(openSnackBarAction(errorMessage, 'info'))
   }
}

export function onItemSelection(event, setItemsLists, setItemsByParentItemId) {
   const { name: parentItemId_ItemId, checked } = event.target
   const [parentItemId, itemId] = parentItemId_ItemId.split('_')
   setItemsLists(previous => ({
      ...previous,
      [parentItemId]: {
         ...previous[parentItemId],
         itemsMap: {
            ...previous[parentItemId].itemsMap,
            [itemId]: {
               ...previous[parentItemId].itemsMap[itemId],
               checked
            }
         }
      }
   }))
   if (setItemsByParentItemId) {
      setItemsByParentItemId(itemId, checked)
   }
}

export function setItemsByParentItemId(
   parentItemId,
   checkedParentItem,
   itemsLists,
   setItemsLists,
   searchItemsByParentItemId,
   childItemsLists,
   setChildItemByItemId
) {
   if (itemsLists.hasOwnProperty(parentItemId)) {
      if (!checkedParentItem && childItemsLists && setChildItemByItemId) {
         const itemsMap = itemsLists[parentItemId].itemsMap
         for (const itemId in itemsMap) {
            if (childItemsLists.hasOwnProperty(itemId)) {
               setChildItemByItemId(itemId, false)
            }
         }
      }
      setItemsLists(previous => ({
         ...previous,
         [parentItemId]: {
            ...previous[parentItemId],
            visible: checkedParentItem,
            itemsMap: checkedParentItem
               ? previous[parentItemId]?.itemsMap
               : deselectItems(previous[parentItemId]?.itemsMap)
         }
      }))
   } else if (checkedParentItem) {
      searchItemsByParentItemId(parentItemId)
   }
}

export function shouldShowItemList(
   itemsLists,
   setShowItemsList, 
   setSelectedOptions, 
   optionKey
) {
   const shouldShow = Object.keys(itemsLists).some(
      parentItemId => itemsLists[parentItemId].visible
   )
   setShowItemsList(shouldShow)
   setSelectedOptions(previous => ({
      ...previous,
      [optionKey]: getSelectedOptionsWithParent(itemsLists)
   }))
}
